import Vue from 'vue';
import Vuex from 'vuex';
import auth from '@/store/modules/auth';
import rate from '@/store/modules/rate';
import place from '@/store/modules/place';
import question from '@/store/modules/question';
import owner from '@/store/modules/owner';
import search from '@/store/modules/search';
import pdf from '@/store/modules/pdf';
import organization from '@/store/modules/organization';
import profiles from '@/store/modules/profiles';
import comment from '@/store/modules/comment';
import closeAccount from '@/store/modules/closeAccount';
import startQuestions from '@/store/modules/startQuestions';
import stickerTemplates from '@/store/modules/stickerTemplates';
import payment from '@/store/modules/payment';
import shortLinks from '@/store/modules/shortLinks';
import questionManage from '@/store/modules/questionManage';
import googleBusinesses from '@/store/modules/googleBusinesses';
import airLead from '@/store/modules/airLead'
import serviceLog from '@/store/modules/serviceLog'
import serviceRequest from '@/store/modules/serviceRequest'
import userActions from '@/store/modules/userActions'
import hubspotLeads from '@/store/modules/hubspotLeads'
import locations from '@/store/modules/locations'

Vue.use(Vuex);

const lat = localStorage.getItem('lat');
const lng = localStorage.getItem('lng');
const mapZoom = localStorage.getItem('zoom');
const currentLanguage = localStorage.getItem('lang');

const store = new Vuex.Store({
    state: {
        apiKey: 'AIzaSyBRbSm7ZE5ofSJxHan56oyF9tr9SxXcHw4',
        lat: lat,
        lng: lng,
        mapZoom: mapZoom,
        sessionToken: null,
        currentLanguage: currentLanguage || null,
        infoEmailAdress: 'team@air-vote.com',
        feedbackEmailAdress: 'feedback@air-vote.com',
        scrolledItem: null,
        voted: false,
        isMobile: window.outerWidth <= 1000 ? true : false,
        messageModel: null,
        progressBarTag: null
        // voted: JSON.parse(localStorage.getItem('voted')) || false
    },

    getters: {
        getFormatedLang(state) {
            return state.currentLanguage
        }
    },

    mutations: {
        setVotedState(state, value) {
            state.voted = value
            // localStorage.setItem('voted', value);
        },

        setLanguage(state, lang) {
            state.currentLanguage = lang
            localStorage.setItem('lang', lang)
        },

        setMapCordinates(state, map) {
            console.log(`setMapCordinates: `, map.center.lat(), map.center.lng(), map.zoom)
            state.lat = map.center.lat();
            state.lng = map.center.lng();
            state.mapZoom = map.zoom;
            localStorage.setItem('lat', map.center.lat());
            localStorage.setItem('lng', map.center.lng());
            localStorage.setItem('zoom', map.zoom);
        },

        setSessionToken(state, token) {
            state.sessionToken = token;
        },

        saveScrolledItem(state, idToScroll) {
            state.scrolledItem = idToScroll
        },

        setMessageModel(state, item) {
            state.messageModel = item
        },

        setProgressBarTag(state, tag) {
            state.progressBarTag = tag
        }
    },

    actions: {},

    modules: {
        closeAccount,
        organization,
        profiles,
        question,
        comment,
        search,
        place,
        owner,
        auth,
        rate,
        pdf,
        startQuestions,
        stickerTemplates,
        payment,
        shortLinks,
        questionManage,
        googleBusinesses,
        airLead,
        serviceLog,
        serviceRequest,
        userActions,
        hubspotLeads,
        locations,
    },
});

export default store;
